<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="publication-breakdown-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
          </button>

          <h4 class="modal-title">
            Publication Breakdown
          </h4>
        </div>

        <LoadingSpinner v-if="loading"/>

        <div v-else class="modal-body">
          <div>
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation" class="active"><a href="#orders" aria-controls="home" role="tab"
                                                        data-toggle="tab">Orders</a></li>
              <li role="presentation"><a href="#ad-formats" aria-controls="profile" role="tab" data-toggle="tab">Ad
                Formats</a></li>
            </ul>

            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="orders">
                <table class="table table-striped">
                  <thead>
                  <tr>
                    <th class="col-xs-6">
                      Company
                    </th>

                    <th class="col-xs-4">
                      Order
                    </th>

                    <th class="col-xs-5">
                      Portal
                    </th>

                    <th class="col-xs-5">
                      Category
                    </th>

                    <th class="col-xs-4 text-right">
                      Price
                    </th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr v-for="row in orderRows">
                    <td class="table__ellipsis">
                      <router-link :to="'/companies/' + row.company_id" data-dismiss="modal">
                        {{ row.company_name }}
                      </router-link>
                    </td>

                    <td class="table__ellipsis">
                      <router-link :to="'/companies/' + row.company_id + '/orders/' + row.order_id"
                                   data-dismiss="modal">
                        #{{ row.order_id }}
                      </router-link>
                    </td>

                    <td class="table__ellipsis">
                      <router-link :to="'/portals/' + row.portal_id" data-dismiss="modal">
                        {{ row.portal_name }}
                      </router-link>
                    </td>

                    <td class="table__ellipsis">
                      <span v-if="row.ad_category === 'publication-ads'" class="label label-success">
                        Publication
                      </span>

                      <span v-if="row.ad_category === 'time-ads'" class="label label-info">
                        Time
                      </span>
                    </td>

                    <td class="table__ellipsis text-right">
                      {{ row[metric] | price }}
                    </td>
                  </tr>
                  </tbody>

                  <tfoot>
                  <tr>
                    <td colspan="4" class="text-right">
                      <b>
                        Total
                      </b>
                    </td>

                    <td class="text-right">
                      <b>
                        {{ ordersTotal | price }}
                      </b>
                    </td>
                  </tr>
                  </tfoot>
                </table>

                <SimplePager :current-page="orderPage" :last-page="ordersLastPage" @navigate="orderPage = $event"/>
              </div>

              <div role="tabpanel" class="tab-pane" id="ad-formats">
                <table class="table table-striped">
                  <thead>
                  <tr>
                    <th class="col-xs-2"></th>

                    <th class="col-xs-7">
                      Ad Format
                    </th>

                    <th class="col-xs-6">
                      Channel
                    </th>

                    <th class="col-xs-5">
                      Category
                    </th>

                    <th class="col-xs-4 text-right">
                      Price
                    </th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr v-for="row in adFormatRows">
                    <td class="text-center">
                      <input type="checkbox" :value="row" v-model="selected" style="margin: 0">
                    </td>

                    <td class="table__ellipsis">
                      {{ row.ad_format_name }}
                    </td>

                    <td class="table__ellipsis">
                      {{ row.channel_name }}
                    </td>

                    <td class="table__ellipsis">
                      <span v-if="row.ad_category === 'publication-ads'" class="label label-success">
                        Publication
                      </span>

                      <span v-if="row.ad_category === 'time-ads'" class="label label-info">
                        Time
                      </span>
                    </td>

                    <td class="table__ellipsis text-right">
                      {{ row[metric] | price }}
                    </td>
                  </tr>
                  </tbody>

                  <tfoot>
                  <tr>
                    <td colspan="4" class="text-right">
                      <b>
                        Total
                      </b>
                    </td>

                    <td class="text-right">
                      <b>
                        {{ adFormatsTotal | price }}
                      </b>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="4" class="text-right">
                      <b>
                        Selected Total
                      </b>
                    </td>

                    <td class="text-right">
                      <b>
                        {{ selected.reduce((total, row) => total + parseFloat(row[metric]), 0) | price }}
                      </b>
                    </td>
                  </tr>
                  </tfoot>
                </table>

                <SimplePager
                    :current-page="adFormatPage"
                    :last-page="adFormatsLastPage"
                             @navigate="adFormatPage = $event"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import ResourcePager from '@/components/Utilities/Pagination/ResourcePager'
import SimplePager from '../../../Lists/SimplePager'

export default {
  components: {SimplePager, ResourcePager, LoadingSpinner},

  props: {
    period: {
      required: true
    },

    portal: {
      required: true
    },

    user: {
      required: false
    },

    granularity: {
      required: true
    },

    selectedChannel: {
      required: false
    },

    selectedTimeSubchannel: {
      required: false
    },

    fixedFilters: {
      required: false,
      default: () => []
    },

    metric: {
      required: false,
      default: 'ad_value_after_costs'
    }
  },

  data() {
    return {
      orders: null,
      adFormats: null,

      selected: [],

      orderPage: 1,
      adFormatPage: 1,
      loading: true
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  watch: {
    period() {
      this.load()
    },

    portal() {
      this.load()
    },

    user() {
      this.load()
    },

    selectedChannel() {
      this.load()
    },

    selectedTimeSubchannel() {
      this.load()
    }
  },

  computed: {
    orderRows() {
      return this.orders.slice((this.orderPage - 1) * 10, this.orderPage * 10)
    },

    ordersLastPage() {
      return Math.ceil(this.orders.length / 10)
    },

    ordersTotal() {
      return Math.round(this.orders.reduce((total, row) => parseFloat(row[this.metric]) + total, 0))
    },

    adFormatRows() {
      return this.adFormats.slice((this.adFormatPage - 1) * 10, this.adFormatPage * 10)
    },

    adFormatsLastPage() {
      return Math.ceil(this.adFormats.length / 10)
    },

    adFormatsTotal() {
      return Math.round(this.adFormats.reduce((total, row) => parseFloat(row[this.metric]) + total, 0))
    },

    granularityDimension() {
      if (this.granularity === 'months') {
        return 'publish_month'
      }

      return 'publish_quarter'
    },

    granularityFormat() {
      if (this.granularity === 'months') {
        return 'MM/YYYY'
      }

      return '[Q]Q/YYYY'
    },

    filters() {
      let filters = [
        {dimension: this.granularityDimension, operator: '=', value: this.period.format(this.granularityFormat)},
        {dimension: 'portal_id', operator: '=', value: this.portal.id},
        ...this.fixedFilters
      ]

      if (this.user) {
        filters.push({dimension: 'user_id', operator: '=', value: this.user})
      }

      if (this.selectedChannel) {
        filters.push({dimension: 'channel', operator: '=', value: this.selectedChannel},)
      }

      if (this.selectedTimeSubchannel) {
        filters.push({dimension: 'time_based_subchannel_id', operator: '=', value: this.selectedTimeSubchannel},)
      }

      return filters
    },

    selectedTotal() {
      return 0
    }
  },

  methods: {
    load() {
      this.loading = true

      Promise.all([
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: this.metric},
          ],
          dimensions: [
            {name: 'company_id'},
            {name: 'company_name'},
            {name: 'order_id'},
            {name: 'portal_id'},
            {name: 'portal_name'},
            {name: 'ad_category'},
          ],
          filters: this.filters
        }),
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: this.metric},
          ],
          dimensions: [
            {name: 'ad_format'},
            {name: 'ad_format_name'},
            {name: 'channel_name'},
            {name: 'ad_category'},
          ],
          filters: this.filters
        })
      ]).then(responses => {
        this.orders = responses[0].data.data

        this.orders.sort((a, b) => a.company_name < b.company_name ? -1 : 1)

        this.adFormats = responses[1].data.data

        this.adFormats.sort((a, b) => a.ad_format_name < b.ad_format_name ? -1 : 1)

        this.loading = false

      })
    },

    hide() {
      $(this.$el).modal('hide')
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    reset() {
      this.orderPage = 1

      this.adFormatPage = 1

      this.selected = []
    }
  }
}
</script>
